export function getDevicePixelRatio() {
  return window.devicePixelRatio || 2;
}
